import { MedicalDeviceOrdersHistoryTable } from './medicalDeviceOrdersTable/MedicalDeviceOrdersHistoryTable';

type MedicalDeviceOrdersHistoryProps = {
   readonly patientId: number;
   readonly visitId: number;
};

export const MedicalDeviceOrdersHistory = (props: MedicalDeviceOrdersHistoryProps): JSX.Element => {
   return <MedicalDeviceOrdersHistoryTable patientId={props.patientId} visitId={props.visitId} />;
};
